import { NgModule } from '@angular/core';

import { EffectsModule, provideEffects } from '@ngrx/effects';
import { provideState, StoreModule } from '@ngrx/store';

import { GrowRolesEffects } from './store/grow-roles/grow-roles.effects';
import { GrowRolesNamespace, GrowRolesReducer } from './store/grow-roles/grow-roles.store';
import { PositionSkillsEffects } from './store/position-skills/position-skills.effects';
import {
  PositionSkillsNamespace,
  PositionSkillsReducer,
} from './store/position-skills/position-skills.store';
import { SkillsEffects } from './store/skills/skills.effects';
import { SkillsNamespace, SkillsReducer } from './store/skills/skills.store';

export const skillsStoreProvider = provideState(SkillsNamespace, SkillsReducer);
export const skillsEffectsProvider = provideEffects([SkillsEffects]);

export const positionSkillsStoreProvider = provideState(
  PositionSkillsNamespace,
  PositionSkillsReducer,
);
export const positionSkillsEffectsProvider = provideEffects([PositionSkillsEffects]);

export const growRolesStoreProvider = provideState(GrowRolesNamespace, GrowRolesReducer);
export const growRolesEffectsProvider = provideEffects([GrowRolesEffects]);

export const provideSkillsStore = [
  skillsStoreProvider,
  skillsEffectsProvider,
  positionSkillsStoreProvider,
  positionSkillsEffectsProvider,
  growRolesStoreProvider,
  growRolesEffectsProvider,
];

@NgModule({
  imports: [
    StoreModule.forFeature(SkillsNamespace, SkillsReducer),
    EffectsModule.forFeature([SkillsEffects]),
    StoreModule.forFeature(PositionSkillsNamespace, PositionSkillsReducer),
    EffectsModule.forFeature([PositionSkillsEffects]),
    StoreModule.forFeature(GrowRolesNamespace, GrowRolesReducer),
    EffectsModule.forFeature([GrowRolesEffects]),
  ],
})
export class SkillsStoreDataModule {}
